import { useState, useEffect } from "react";
import { NewsDetails } from "@/@types";
import { FallbackImage, ShareSocialMedia } from "../common";
import { ParsedContent } from "../common/ParsedContent"

type Props = {
  newsDetails: NewsDetails;
};

export default function NewsDetailsCard({ newsDetails }: Props) {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
    }
  }, []);

  const formatDate = new Date(newsDetails.date)
    .toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .toUpperCase();

  if (!newsDetails) {
    return (
      <div>
        <h1>Noticia no encontrada.</h1>
        <p>No hay detalles disponibles para esta noticia.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="overflow-hidden">
        <div className="flex flex-col md:flex-row bg-white overflow-hidden w-full max-w-full mx-auto">
          <div className="md:w-1/2 aspect-video p-4">
            <FallbackImage
              width={672}
              height={364}
              sizes="960px"
              src={newsDetails.media}
              alt={newsDetails.title}
            />
          </div>

          <div className="md:w-1/2 p-6 flex flex-col justify-between">
            <div>
              <p className="text-sm bg-dark02 text-white inline-block px-3 py-1 mb-4">
                {newsDetails.category.name}
              </p>
              <h2 className="text-2xl font-bold text-dark02 mb-4">
                {newsDetails.title}
              </h2>
            </div>
            <div className="flex items-center justify-between bg-light01 py-2 px-4">
              <p className="text-dark02">{formatDate}</p>
              {currentUrl && (
                <ShareSocialMedia
                  shareUrl={currentUrl}
                  containerClassName="flex gap-2 text-gray03"
                  textClassName="text-sm text-dark02 uppercase font-bold"
                  label="compartir en"
                />
              )}
            </div>
          </div>
        </div>

        {newsDetails.description && (
          <div className="p-5 bg-white w-full max-w-full mx-auto overflow-hidden">
            <p className="text-dark02">{newsDetails.description}</p>
          </div>
        )}

        <div className="p-5 bg-white w-full mx-auto overflow-hidden">
          <ParsedContent content={newsDetails.longDescription} />
        </div>

        <div className="flex items-center justify-between py-2 px-4">
          <p className="text-sm text-gray-500">{formatDate}</p>
          {currentUrl && (
            <ShareSocialMedia
              shareUrl={currentUrl}
              containerClassName="flex gap-2 text-gray03"
              textClassName="text-sm text-dark02 uppercase font-bold"
              label="compartir en"
            />
          )}
        </div>
      </div>
    </div>
  );
}